<template>
  <b-container fluid>
    <div v-if="loading" class="text-center">
      <b-icon icon="three-dots" animation="cylon" font-scale="5" variant="gray-600"></b-icon>
    </div>
    <div v-else-if="employees.length === 0">
      <div class="text-gray-600 text-center">Elija una empresa</div>
    </div> 
    <b-card no-body class="border-gray" v-else>
      <b-table
        class="text-right mb-0" 
        v-if="employees.length>0" 
        hover 
        :items="employees" 
        :fields="fields"
        :stacked="'md'"
        foot-clone 
      >
        <template #cell(code)="data">
          <b-icon if="data.item.details.closed" icon="lock"></b-icon>
          {{ data.item.details.code }}
        </template>
  
        <template #cell(name)="data">
          {{ data.item.details.name }}
        </template>
  
        <template #cel(job_title)="data">
          {{ data.item.details.job_title }}
        </template>
  
        <template v-for="f in categoryFields" v-slot:[generatecell(f.key)]="data">
          <money-badge href="#" 
            class="position-relative" 
            @click="toggle(data.index, f.key)" 
            without-currency clickable 
            :money="data.item.amountForCategory(f.key)" 
            :ref="'badge_' + data.index + '_' + f.key"
            :key="'badge_' + data.index + '_' + f.key"
          ></money-badge>
          <transition name="bounce">
            <div v-if="detailsShown[data.index][f.key] && data.item.addendCategoryBreakdown(f.key).length>0" 
              class="position-fixed"
              style="width: 100%; height: 100%; top: 0px; left: 0px; z-index: 100; background: rgba(0,0,0,0.6);" >
              <b-table 
                class="bounce-inner bg-white"
                style="position: absolute; width:50%; border:solid" 
                :fields="categoryFieldsFor(data.item, f.key)" 
                :items="data.item.addendCategory(f.key).formattedBreakdown"
                :stacked="'md'"
                v-hold="$refs['badge_' + data.index + '_' + f.key]"
              >
                <template #cell(value)="data">
                  <money-badge without-currency :money="data.value"></money-badge>
                </template>
              </b-table>
            </div>
          </transition>
        </template>
        <template v-slot:cell(total)="data">
          <money-badge :money="data.item.value"></money-badge>
        </template>
    
        <template v-for="c in categoryFields" v-slot:[generatehead(c.key)]="data">
          <div v-b-popover.hover="columnFullName(data.column)" 
            v-if="columnFullName(data.column)!==data.label"
          >{{data.label}}</div>
          <div v-else>{{data.label}}</div>
        </template>
    
        <template v-slot:foot(code)="data">
          -
        </template>
  
        <template v-slot:foot(job_title)="data">
          Totales
        </template>
        <template v-slot:foot(name)="data">
          -
        </template>
    
        <template v-for="(money, index) in totals" v-slot:[generatefoot(index)]="data">
          <money-badge href="#" :without-currency="index != 'total'" :money="money"></money-badge>
        </template>
    
      </b-table>
    </b-card>
  </b-container>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import MoneyBadge from '../common/MoneyBadge.vue';
import hold from '../../directives/hold';

export default {
  props: {
    employees: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  directives: {
    hold
  },
  data() {
    return {
      
    }
  },
  components: {
    MoneyBadge
  },
  computed: {
    ...mapState('payroll', [
      'totals',
      'detailsShown',
      'loading',
    ]),
    ...mapGetters('payroll', [
      'categoryFields' 
    ]),
  },
  methods: {
    ...mapMutations('payroll', [
      'toggleShowDetails',
    ]),
    toggle(e, c){
      this.toggleShowDetails({e, c});
    },
    columnFullName(key){
      return this.categoryFields.find(c=>c.key===key).full
    },
    generatecell(key) {
      return `cell(${key})`;
    },
    generatehead(key) {
      return `head(${key})`;
    },
    generatefoot(key) {
      return `foot(${key})`;
    },
    categoryFieldsFor(b, k){
      return b.addendCategory(k).breakdownFields
        .concat([
          {key:'value', label:'Total'}
        ]);
    }
  }
}
</script>
